import { UserRole, SearchField, SortField, SortOrder } from 'state/user/UserTypes';
import { FluxStandardAction } from 'state/StateTypes';
import { createReducer } from 'utils';
import * as actionTypes from './QueryActionTypes';

export interface QueryState {
   type: UserRole;
   page: number;
   sortField: SortField;
   sortOrder: SortOrder;
   limit: number;
   search?: string;
   searchField: SearchField;
}

const assignPayloadToState = <T>({ payload }: FluxStandardAction, prop: keyof QueryState): Partial<QueryState> => ({
   [prop]: payload as T,
});

const initialQuery: QueryState = { type: 'customer', page: 1, searchField: SearchField.lastName, sortField: SortField.lastName, sortOrder: SortOrder.ascending, limit: 20 }

const QueryReducer = createReducer<QueryState, FluxStandardAction>(
   initialQuery,
   {
      [actionTypes.SET_QUERY_TYPE]: (state, action) => ({
         ...state,
         ...assignPayloadToState<UserRole>(action, 'type'),
      }),
      [actionTypes.SET_QUERY_PAGE]: (state, action) => ({
         ...state,
         ...assignPayloadToState<number>(action, 'page'),
      }),
      [actionTypes.SET_QUERY_SEARCH]: (state, action) => ({
         ...state,
         search: decodeURIComponent(action.payload) as string,
      }),
      [actionTypes.CLEAR_QUERY_SEARCH]: state => ({
         ...state,
         search: undefined,
      }),
      [actionTypes.SET_QUERY_SEARCH_FIELD]: (state, action) => ({
         ...state,
         ...assignPayloadToState<SearchField>(action, 'searchField'),
      }),
      [actionTypes.SET_QUERY_SORT_FIELD]: (state, action) => ({
         ...state,
         ...assignPayloadToState<SortField>(action, 'sortField'),
      }),
      [actionTypes.SET_QUERY_SORT_ORDER]: (state, action) => ({
         ...state,
         ...assignPayloadToState<SortOrder>(action, 'sortOrder'),
      }),
      //not currently in use
      [actionTypes.SET_QUERY_LIMIT]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'limit'),
      }),
      [actionTypes.RESET_QUERY]: () => initialQuery
   }
);

export default QueryReducer;
